import { useOutletContext } from "react-router-dom";
import SearchSimple from "../../../../components/SearchSimples/SearchSimple";
import CustomTable from "../../../../components/table/CustomTable";
import { permissionObj } from "../../../../Helpers/permission";
import DeleteModal from "../../../Modals/DeleteModal";
import FineTypesApp from "./Functionality/FineTypesApp";
import AddEditFineType from "./Modal/AddEditFineType";
import { MODAL_NAMES, toggleFinesModal } from "./Model/Model";
import CustomButtonLink from "../../../../components/buttons/CustomButtonLink";

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 *
 * @description
 * `FineTypes` component manages the list and CRUD operations of traffic fine types.
 * It allows administrators to view, search, create, update, and delete fine types.
 * Depending on user permissions, certain actions and UI elements will be available.
 *
 * @component
 * @param {Object} props - Component properties.
 * @param {boolean} props.modified - Indicates if the table data has been modified.
 * @param {boolean} props.DEV - Enables development mode with unrestricted permissions.
 * @param {Array<string>} props.permission - List of current user permissions.
 * @param {Function} props.handleCloseFinesModal - Function to close any active fine modals.
 *
 * @returns {JSX.Element} Rendered component for managing fine types.
 */

const FineTypes = ({modified}) => {

    const {
        t,
        DEV,
        permission,
        tableId,
        searchId,
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        getActionsButtons,
        pagination,
        isAllChecked,
        setBodyForExport,
        setSearchResults,
        setSearchElement,
        option,
        rowsPerPage,
        setSimpleSearch,
        search,
        setSearch,
        setFinalArray,
        searchElement,
        handleDelete,
        handleSelectForDelete,
        setIsAllChecked,
        setModified
    } = FineTypesApp({
        modified
    });

  // Retrieve outlet context (fineType state and setter)
  const { fineType, setFineType } = useOutletContext()


    return (<>

        <div className='w-100'>
            <SearchSimple
                id={searchId}
                setBodyForExport={setBodyForExport}
                setSearchResults={setSearchResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSimpleSearch={setSimpleSearch}
                search={search}
                setSearch={setSearch}
                contractorId={null}
                supplierId={null}
            />
        </div>

        <>
            <CustomTable tableId={tableId}
                         searchId={searchId}
                         checkbox={DEV || permission?.includes(permissionObj?.WEB_FINE_TYPE_DELETE)}
                         checkboxTitle={"de_/_select_all"}
                         isAllChecked={isAllChecked}
                         onChangeCheckbox={handleDeleteAll}
                         thead={thead}
                         tbody={tbody}
                         columnActions={DEV || permission?.includes(permissionObj?.WEB_FINE_TYPE_DELETE) || permission?.includes(permissionObj?.WEB_FINE_TYPE_UPDATE)}
                         getActionsButtons={getActionsButtons}
                         handleCheckboxChange={handleCheckboxChange}
                         selectedList={fineType.selectForDelete}
                         childrenNotInformation={tbody?.data?.length === 0 ?
                             <>
                                 <div className={"warning-text"}>
                                     <p>{t("you_have_not_created_any_types_yet")}</p>
                                 </div>
                                 {(DEV || permission?.includes(permissionObj?.WEB_FINE_TYPE_CREATE)) &&
                                 <CustomButtonLink
                                     className={'d-block'}
                                     splitName={false}
                                     id={'btn_ft_create_fine_type'}
                                     card={true}
                                     onClick={() => {
                                         toggleFinesModal(MODAL_NAMES.CREATE, setFineType)
                                     }}
                                     name='add_a_new_type'
                                 />
                                 }
                             </>
                             : undefined
                         }
            />
            {pagination()}
        </>


        <AddEditFineType
            onHide={() => toggleFinesModal(MODAL_NAMES.EDIT, setFineType, false)}
            setModified={setModified}
        />

        <DeleteModal
            title_modal="delete_fine_type"
            show={fineType.isDeleteModal}
            onHide={() => {
                toggleFinesModal(MODAL_NAMES.DELETE, setFineType, false)
            }}
            onClickFn={handleDelete}
            data={fineType.selectForDelete}
            isReset={handleSelectForDelete}
            isAllReset={setIsAllChecked}
            element_modal="fine_type"
        />
    </>)
}
export default FineTypes;
